import { Flex, Switch, Text } from "@chakra-ui/react";
import { FormattedMessage } from "react-intl";

import {
  FeatureKey,
  useBackendFeatureFlag,
  useFeatureFlagKeys,
  useSetFeatureFlag,
} from "@nens/ranalib";

import { StatusBanner } from "@/components/status-banner";

const FeatureFlagSwitch = ({ feature }: { feature: FeatureKey }) => {
  const [override, setOverride] = useSetFeatureFlag(feature);
  const backendValue = useBackendFeatureFlag(feature);
  const isEnabled = override ?? backendValue;

  return (
    <Switch size="sm" isChecked={isEnabled} onChange={(event) => setOverride(event.target.checked)}>
      {feature} (default is {backendValue ? "on" : "off"} by backend)
    </Switch>
  );
};

export function FeatureFlagsBanner() {
  const featureKeys = useFeatureFlagKeys();

  return (
    <StatusBanner
      status="info"
      title={<FormattedMessage id="feature_flags" defaultMessage="Feature flags" />}
      description={
        <Flex flexDirection="column" gap={2} whiteSpace="normal">
          <Text fontSize="sm">
            <FormattedMessage
              id="feature_flags.description"
              defaultMessage="Override feature flags for this browser."
            />
          </Text>
          {featureKeys.map((feature) => (
            <FeatureFlagSwitch key={feature} feature={feature} />
          ))}
        </Flex>
      }
      ariaLabel="Open feature flags"
    />
  );
}
